"use strict";

module.exports = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/ext/global-this/is-implemented.js
// module id = ../../../node_modules/ext/global-this/is-implemented.js
// module chunks = 1